import React from "react";

export default function useClickOutside(ref: $TSFixMe, action: $TSFixMe) {
  React.useEffect(() => {
    function handleClickOutside(event: $TSFixMe) {
      if (ref.current && !ref.current.contains(event.target)) {
        action();
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);
}
